var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.08 20.0799L18.73 16.0399C19.21 15.6999 19.5 15.1499 19.5 14.5599C19.5 13.0699 17.82 12.2099 16.61 13.0699L12.5 15.9999L8.39 13.0699C7.18 12.1999 5.5 13.0699 5.5 14.5599C5.5 15.1499 5.79 15.7099 6.27 16.0499L11.92 20.0899C12.27 20.3299 12.73 20.3299 13.08 20.0799Z",
    fill: "#EE3932"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.08 13.0799L18.73 9.04992C19.21 8.69992 19.5 8.14992 19.5 7.55992C19.5 6.06992 17.82 5.19992 16.61 6.06992L12.5 8.99992L8.39 6.06992C7.18 5.19992 5.5 6.06992 5.5 7.55992C5.5 8.14992 5.79 8.70992 6.27 9.04992L11.92 13.0899C12.27 13.3299 12.73 13.3299 13.08 13.0799Z",
    fill: "#EE3932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.dcc90804307ca520902940ab3bcfb829.svg";
export { ForwardRef as ReactComponent };